import { CSSProperties } from "react";
import { TypographyVariant } from "./types";

export const variants: Record<TypographyVariant, CSSProperties> = {
  h1: {
    fontFamily: "var(--font-family-heading)",
    fontSize: "var(--font-size-lg4)",
    fontWeight: "var(--font-weight-bold)",
  },
  h2: {
    fontFamily: "var(--font-family-heading)",
    fontSize: "var(--font-size-lg3)",
    fontWeight: "var(--font-weight-bold)",
  },
  h3: {
    fontFamily: "var(--font-family-heading)",
    fontSize: "var(--font-size-lg2)",
    fontWeight: "var(--font-weight-bold)",
  },
  h4: {
    fontFamily: "var(--font-family-heading)",
    fontSize: "var(--font-size-md2)",
    fontWeight: "var(--font-weight-bold)",
  },
  h5: {
    fontFamily: "var(--font-family-heading)",
    fontSize: "var(--font-size-md)",
    fontWeight: "var(--font-weight-bold)",
  },
  body: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-sm)",
    fontWeight: "var(--font-weight-regular)",
    lineHeight: "20px",
  },
  "body-strong": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-sm)",
    fontWeight: "var(--font-weight-bold)",
    lineHeight: "20px",
  },
  "body-big": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-md)",
    fontWeight: "var(--font-weight-regular)",
  },
  "body-big-strong": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-md)",
    fontWeight: "var(--font-weight-bold)",
  },
  "body-small": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-xs)",
    fontWeight: "var(--font-weight-regular)",
  },
  "body-small-strong": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-xs)",
    fontWeight: "var(--font-weight-bold)",
  },
  "body-main-header": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-sm2)",
    fontWeight: "var(--font-weight-regular)",
  },
  "body-main-header-strong": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-sm2)",
    fontWeight: "var(--font-weight-bold)",
  },
  label: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-xs2)",
    fontWeight: "var(--font-weight-regular)",
  },
  "label-strong": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-xs2)",
    fontWeight: "var(--font-weight-bold)",
  },
  "button-label": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-sm)",
    fontWeight: "var(--font-weight-bold)",
  },
  "button-mini-label": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-xs)",
    fontWeight: "var(--font-weight-bold)",
  },
  tag: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-xxs)",
    fontWeight: "var(--font-weight-bold)",
    textTransform: "uppercase",
  },
  "status-button": {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-size-xxs)",
    fontWeight: "var(--font-weight-bold)",
    textTransform: "uppercase",
  },
};
